export { default } from './alert-info';
